// function is meant to be binded before using
// this.props.changeFormValue should be present in the component
export function createInputHandler (name, type = 'input') {
  return (e, input) => {
    let valueSelector = {
      input: () => {
        return e.target.value;
      },
      select: () => {
        return input.value;
      }
    };

    this.props.changeFormValue(name, valueSelector[type]());
  };
}


// WEBPACK FOOTER //
// ./client/helpers/utils.js